import React from 'react';

/**
 * The "open this record" affordance, shared by every voucher list.
 *
 * An icon rather than a "View" label: these tables are already wide, and the
 * word was costing a column's worth of width on screens that need it for the
 * figures.
 */
export default function EyeButton({ onClick, title = 'View voucher' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 30, height: 30, borderRadius: 8, cursor: 'pointer',
        background: 'var(--bg-card)', border: '1px solid #0b318b', color: '#0b318b',
        transition: 'background 0.15s, color 0.15s',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = '#0b318b'; e.currentTarget.style.color = '#fff'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bg-card)'; e.currentTarget.style.color = '#0b318b'; }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </button>
  );
}
